<script lang="ts">
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function restartForm(){
    dispatch("restart");
  }

</script>

<div class="text-center">
  <p>
    Une erreur a été rencontrée avec les informations bancaires renseignées.
  </p>

  <div class="d-flex align-content-center justify-content-center gap-3">
    <button class="btn btn-primary" on:click={restartForm}>Recommencer le formulaire</button>
    <a class="btn btn-outline-primary text-decoration-none" href="mailto:lba@lbaconseil.fr">Contacter LBA</a>
  </div>

</div>